export const engineTypeFilter = {
    'name': {
        'inputType': 'text',
        'title': 'Name',
    },
    'engine_family': {
        'inputType': 'dropdown',
        'title': 'Engine Family',
        'options': [],
        'labelKey': 'name',
        'valueKey': 'id',
    },
    'aircraft_body_type': {
        'inputType': 'dropdown',
        'title': 'Aircraft Body Type',
        'options': [],
        'labelKey': 'label',
        'valueKey': 'label',
    },
    'aircraft_type': {
        'inputType': 'dropdown',
        'title': 'Aircraft Type',
        'options': [],
        'labelKey': 'name',
        'valueKey': 'id',
        'multiple': true
    },
}; 